import CityPageTemplate from "../city-template/CityPageTemplate";
import { belfastConfig } from "./data";

export default function BelfastPage() {
  return <CityPageTemplate config={belfastConfig} />;
}